// Header

$('#identity #logo a').on('click', function() {
  	if ($(window).width() < 761) {
        //ga('send', 'event', 'Header', 'Mobile - Logo Rockford Collection', 'Click');
		gtag('event', 'Header - Mobile - Logo Rockford Collection', {
		  'event_type': 'Header',
		  'event_name': 'Header - Mobile - Logo Rockford Collection'
		});
    } else {
		//ga('send', 'event', 'Header', 'Desktop - Header - Logo', 'Click');
		gtag('event', 'Header - Desktop - Logo', {
		  'event_type': 'Header',
		  'event_name': 'Header - Desktop - Logo'
		});
    }
});

$('#navigation #nav a').on('click', function() {
  	var this_text = $(this).text();
	//ga('send', 'event', 'Header', 'Desktop - Menu - '+this_text, 'Click');
	gtag('event', 'Header - Desktop - Menu - '+this_text, {
	  'event_type': 'Header',
	  'event_name': 'Header - Desktop - Menu - '+this_text
	});
});
$("#mobile-menu").on("click", ".shifter-handle", function(){
    if ($(this).hasClass('active')) {
        //ga('send', 'event', 'Header', 'Mobile - Topbar - Hamburger Close', 'Click');
        gtag('event', 'Header - Mobile - Topbar - Hamburger Close', {
		  'event_type': 'Header',
		  'event_name': 'Header - Mobile - Topbar - Hamburger Close'
		});
    } else {
        //ga('send', 'event', 'Header', 'Mobile - Topbar - Hamburger Open', 'Click');
        gtag('event', 'Header - Mobile - Topbar - Hamburger Open', {
		  'event_type': 'Header',
		  'event_name': 'Header - Mobile - Topbar - Hamburger Open'
		});
    }
}); 

$('.mobile-navigation li a').on('click', function() {
    var this_text = $(this).text();
	//ga('send', 'event', 'Header', 'Mobile - Menu - '+this_text, 'Click');
	gtag('event', 'Header - Mobile - Menu - '+this_text, {
	  'event_type': 'Header',
	  'event_name': 'Header - Mobile - Menu - '+this_text
	});
});
$('.mobile-navigation li .mn-item-with-subitems').on('click', function() {
var this_text = $(this).text();
//ga('send', 'event', 'Header', 'Mobile - Menu - '+this_text, 'Click');
gtag('event', 'Header - Mobile - Menu - '+this_text, {
  'event_type': 'Header',
  'event_name': 'Header - Mobile - Menu - '+this_text,
});
});


// Footer

$('footer .footer-calendy').on('click', function() {
	var device = '';
	if ($(window).width() < 960) {
		device = 'Mobile';
	} else {
		device = 'Desktop';
	}
	var this_name = '';
	if ($(this).hasClass('footer-calendy-virtual-appointment')) {
		this_name = 'Book a Virtual Appointment';
	} else if ($(this).hasClass('footer-calendy-30min')) {
		this_name = 'Book an Appointment in NYC';
	} else if ($(this).hasClass('footer-calendy-miami')) {
		this_name = 'Book an Appointment in Miami';
	}
	//ga('send', 'event', 'Footer', 'Footer - '+device+' - Contact Us - Calendy -'+this_name, 'Click');

	gtag('event', 'Footer - '+device+' - Contact Us - Calendy -'+this_name, {
	  'event_type': 'Footer',
	  'event_name': 'Footer - '+device+' - Contact Us - Calendy -'+this_name,
	});
});


$('footer .footer_link').on('click', function() {
	var device = '';
	if ($(window).width() < 960) {
		device = 'Mobile';
	} else {
		device = 'Desktop';
	}
    var this_text = $(this).text();
	//ga('send', 'event', 'Footer', 'Footer - Information - '+this_text, 'Click');
	gtag('event', 'Footer - '+device+' - Information - '+this_text, {
	  'event_type': 'Footer',
	  'event_name': 'Footer - '+device+' - Information - '+this_text
	});
});

// Footer

var collection_device = '';
if ($(window).width() < 960) {
	collection_device = 'Mobile';
} else {
	collection_device = 'Desktop';
}
// Collection Page
$(".filter-select").on("click", ".filter-value", function(){
    var this_val = $(this).text();
    var this_text = $(this).parent().parent().find('.filter-title').text();
	//ga('send', 'event', 'Collection Page', 'Collection Page - Filter by - '+this_text+' - '+this_val, 'Click');
	gtag('event', 'Collection Page - '+collection_device+' - Filter by - '+this_text+' - '+this_val, {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - '+collection_device+' - Filter by - '+this_text+' - '+this_val
	});
});
$('#sort-by').on('change', function() {
  	var this_val = $(this).val();
	//ga('send', 'event', 'Collection Page', 'Collection Page - Sort By - '+this_val, 'Click');
	gtag('event', 'Collection Page - '+collection_device+' - Sort By  - '+this_val, {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - '+collection_device+' - Sort By  - '+this_val
	});
});
$('#product-loop .prod-container a').on("click", ".filter-value", function(){
    var this_text = $(this).parent().parent().data('alpha');
	//ga('send', 'event', 'Collection Page', 'Collection Page - '+this_text, 'Click');
	gtag('event', 'Collection Page - '+collection_device+' - Filter - '+this_text, {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - '+collection_device+' - Filter - '+this_text
	});
});
$(document).on('mouseenter', '.col-swatch ul li.color span', function () {  
    var this_val = $(this).parent().data('option-title');
    var this_text = $(this).parent().parent().parent().parent().data('alpha');
	//ga('send', 'event', 'Collection Page', 'Collection Page - '+this_text+' - Color Selector - '+this_val, 'Click');
	gtag('event', 'Collection Page - '+collection_device+' - '+this_text+' - Color Selector - '+this_val, {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - '+collection_device+' - '+this_text+' - Color Selector - '+this_val
	});
}); 
$('.collection #pagination a').on('click', function() {
    var this_text = $(this).text();
  	var last_item = $(this).parent().find('a:nth-last-child(2)').text();
	//ga('send', 'event', 'Front Page', 'Collection Page - Showing Page - '+this_text+'/'+last_item, 'Click');
	gtag('event', 'Collection Page - '+collection_device+' - Showing Page - '+this_text+'/'+last_item, {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - '+collection_device+' - Showing Page - '+this_text+'/'+last_item
	});
});
// Collection Page



// Product Page
$(document).on('click', '.__affirm-logo', function() {
    //ga('send', 'event', 'Product', 'Affirm', 'Click');
    $('.affirm-modal-trigger').click();
    gtag('event', 'Product Page - '+collection_device+' - Affirm Click', {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - '+collection_device+' - Affirm Click'
	});
});

$(".ring-variations-grid").on("click", "a", function(){
    var this_title = $(this).parent().parent().data('rp_name');
	//ga('send', 'event', 'Product Page', 'Product Page - Ring Variations - '+this_title, 'Click');
	gtag('event', 'Product Page - '+collection_device+' - Ring Variations - '+this_title, {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - '+collection_device+' - Ring Variations - '+this_title
	});
});

$('.apb-3-blocks').find('.apb-3-link').on('click', function() {
  	var this_title_block = $(this).parent().find('.apb-3-title').text();
  	var this_title_arr = this_title_block.split(' ');
  	var this_title = this_title_block.replace(this_title_arr[0]+' ', '');
	//ga('send', 'event', 'Product Page', 'Product Page - 3 blocks - '+this_title+' Learn More', 'Click');
	gtag('event', 'Product Page - '+collection_device+' - 3 blocks - '+this_title+' Learn More', {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - '+collection_device+' - 3 blocks - '+this_title+' Learn More'
	});
});

$('.related-products-block a.cy').on('click', function() {
    var this_title = $(this).parent().parent().data('pr_title');
	//ga('send', 'event', 'Product Page', 'Product Page - More in this collection - Clicks', 'Click');
    //ga('send', 'event', 'Product Page', 'Product Page - More in this collection - '+this_title, 'Click');
    gtag('event', 'Product Page - '+collection_device+' - More in this collection - '+this_title, {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - '+collection_device+' - More in this collection - '+this_title
	});
});

$('#custom-fields-accordion .accordion-section a').on('click', function() {
    var this_href = $(this).attr('href');
	//ga('send', 'event', 'Product Page', 'Product Page - Tab '+this_href, 'Click');
	gtag('event', 'Product Page - '+collection_device+' - Tab '+this_href, {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - '+collection_device+' - Tab '+this_href
	});
});

$(".product-reviews").on("click", ".slick-arrow", function(){
  	if ($(this).hasClass('slick-next')) {
        //ga('send', 'event', 'Product Page', 'Product Page - Tab #reviews - Next', 'Click');  
        gtag('event', 'Product Page - '+collection_device+' - Tab #reviews - Next', {
		  'event_type': 'Product Page',
		  'event_name': 'Product Page - '+collection_device+' - Tab #reviews - Next'
		});
    } else {
        //ga('send', 'event', 'Product Page', 'Product Page - Tab #reviews - Prev', 'Click');  
        gtag('event', 'Product Page - '+collection_device+' - Tab #reviews - Prev', {
		  'event_type': 'Product Page',
		  'event_name': 'Product Page - '+collection_device+' - Tab #reviews - Prev'
		});
    }
});

$('#free_shipping_and_returns a').on('click', function() {
  	var this_title = $(this).attr('title');
	//ga('send', 'event', 'Product Page', 'Product Page - Tab #free_shipping_and_returns - '+this_title+' - Learn More', 'Click');
	gtag('event', 'Product Page - '+collection_device+' - Tab #free_shipping_and_returns - '+this_title+' - Learn More', {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - '+collection_device+' - Tab #free_shipping_and_returns - '+this_title+' - Learn More'
	});
});


// Product Page


// Cart Page

$('body.cart').find('.faq-question').click(function(){
    if ($(this).hasClass('faq-open')) { } else {
        //ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Information TAB - '+$(this).text(), 'Click');
        gtag('event', 'Shopping Cart Page - '+collection_device+' - Information TAB - '+$(this).text(), {
		  'event_type': 'Shopping Cart Page',
		  'event_name': 'Shopping Cart Page - '+collection_device+' - Information TAB - '+$(this).text()
		});
    }
});
$('body.cart').find('.faq-answer a').click(function(){
	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - '+$(this).parent().parent().find('.faq-question').text()+' - Learn More', 'Click');
	gtag('event', 'Shopping Cart Page - '+collection_device+' - '+$(this).parent().parent().find('.faq-question').text()+' - Learn More', {
	  'event_type': 'Shopping Cart Page',
	  'event_name': 'Shopping Cart Page - '+collection_device+' - '+$(this).parent().parent().find('.faq-question').text()+' - Learn More'
	});
});
$('body.cart').find('.cl-select').click(function(){
	var select_title = '';
    if ($(this).hasClass('cl-metal-select')) {
    	select_title = 'Metal';
    } else if ($(this).hasClass('cl-size-select')) {
      	select_title = 'Size 1';
    } else if ($(this).hasClass('cl-size2-select')) {
      	select_title = 'Size 2';
    } else if ($(this).hasClass('cl-qty-select')) {
      	select_title = 'Qty';
    }
  	//ga('send', 'event', 'Shopping Cart Page', 'Shopping Cart Page - Select Dropdown - '+select_title, 'Click');
  	gtag('event', 'Shopping Cart Page - '+collection_device+'- Select Dropdown - '+select_title, {
	  'event_type': 'Shopping Cart Page',
	  'event_name': 'Shopping Cart Page - '+collection_device+'- Select Dropdown - '+select_title
	});
});

// Cart Page

// New analytics

if ($(window).width() < 960) {

// $('body').find('.index-rings-content .rdesign-img').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Image - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Image - click'
// 	});
// });
// $('body').find('.index-rings-content h4').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Title - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Title - click'
// 	});
// });
// $('body').find('.index-rings-content .rdesign-variations').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Variations - click'
// 	});
// });
// $('body').find('.index-rings-content .rdesign-variations').find('.irc-dot-item').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - The Legends - '+this_title+' '+this_variations+' - Item Variations - click'
// 	});
// });
// $('body').find('.index-spotted-content_new .isc-item_new').click(function(){
// 	var this_title = $(this).data('s_title');
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Spotted - Video - '+this_title+' - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Spotted - Video - '+this_title+' - click'
// 	});
// });
// $('body').find('.index-spotted-content_new a.isc-content-link.lp-eb-slider-btn.lp-eb-slider-btn-black.irc-btn').click(function(){
// 	var this_title = $(this).parents('.isc-item_new').data('s_title');
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Spotted - Video - '+this_title+' - View Style Btn - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Spotted - Video - '+this_title+' - View Style Btn - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section .hp-rt-item-block-url a').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Discover Collection - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Accordion Block - '+this_title+' - Discover Collection - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section .hp-rt-item-product-content a').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	var this_product = $(this).find('.hp-rt-item-pc-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Product - '+this_product+' - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Accordion Block - '+this_title+' - Product - '+this_product+' - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-right.slick-arrow').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Arrow Right - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Accordion Block - '+this_title+' - Arrow Right - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-left.slick-arrow').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Accordion Block - '+this_title+' - Arrow Left - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Accordion Block - '+this_title+' - Arrow Left - click'
// 	});
// });
// $('body').find('body.index .index-book-an-appointment-block .baa-desc').find('a').click(function(){
// 	var this_title = $(this).text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Mobile - Middle Book an Appointment - '+this_title+' link - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Middle Book an Appointment - '+this_title+' link - click'
// 	});
// });
// $('body').find('.index-book-an-appointment-footer .index-book-an-appointment-block .baa-desc').find('a').click(function(){
// 	var this_title = $(this).text();
// 	//ga('send', 'event', 'Front Page', 'Book an Appointment - Mobile - Book an Appointment - '+this_title+' link - click', 'Click');
// 	gtag('event', 'website_clicks_mobile', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Mobile - Book an Appointment - '+this_title+' link - click'
// 	});
// });
$('body').find('.converted-faq').find('.faq-question').click(function(){
	var this_title = $(this).text();
	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Mobile - '+this_title+' - click', 'Click');
	gtag('event', 'Customer Service Page - Mobile - '+this_title+' - click', {
	  'event_type': 'Customer Service Page',
	  'event_name': 'Customer Service Page - Mobile - '+this_title+' - click'
	});
});
$('body').find('.converted-faq').find('.faq-item').find('a').click(function(){
	var this_title = $(this).parents('.faq-item').find('faq-question').text();
	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Mobile - '+this_title+' - Button - click', 'Click');
	gtag('event', 'Customer Service Page - Mobile - '+this_title+' - Button - click', {
	  'event_type': 'Customer Service Page',
	  'event_name': 'Customer Service Page - Mobile - '+this_title+' - Button - click'
	});
});
$('body.collection').find('.product-index').find('a').click(function(){
	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
	var collection_title = $('body').find('.catdesc-right').find('h1').text();
	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Mobile - '+this_title+' '+this_diamonds+' - click', 'Click');
	gtag('event', 'Collection Page - Mobile - '+collection_title+' - '+this_title+' '+this_diamonds+' - click', {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - Mobile - '+collection_title+' - '+this_title+' '+this_diamonds+' - click'
	});
});
$('body.collection').find('.product-index').find('.col-swatch').find('.color').mouseenter(function(){
	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
	var this_color = $(this).data('option-title');
	var collection_title = $('body').find('.catdesc-right').find('h1').text();
	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Mobile - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover', 'Click');
	gtag('event', 'Collection Page - Mobile - '+collection_title+' - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover', {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - Mobile - '+collection_title+' - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover'
	});
});
$('body.product').find('.rpc-item-inner-columns').find('.rpc-item-inner-column-item').click(function(){
	var this_title = $(this).find('.rpc-item-inner-column-item-title').text();
	var product_title = $('body').find('.product-description').find('h1').text();
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - '+product_title+' - '+this_title+' - click', 'Click');
	gtag('event', 'Collection Page - Mobile - '+collection_title+' - '+product_title+' - '+this_title+' - click', {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - Mobile - '+collection_title+' - '+product_title+' - '+this_title+' - click'
	});
});
$('body.product').find('.rpc-item.rpc-item-dropdown').click(function(){
	var this_title = $(this).find('.rpc-item-title').text();
	var product_title = $('body').find('.product-description').find('h1').text();
	//ga('send', 'event', 'Product Page', 'Product Page - Mobile - '+product_title+' - '+this_title+' - click', 'Click');
	gtag('event', 'Collection Page - Mobile - '+collection_title+' - '+product_title+' - '+this_title+' - click', {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - Mobile - '+collection_title+' - '+product_title+' - '+this_title+' - click'
	});
});

} else {


// $('body').find('.index-rings-content .rdesign-img').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Image - click', 'Click');
// 	gtag('event', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Image - click', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Image - click'
// 	});
// });
// $('body').find('.index-rings-content h4').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Title - click', 'Click');
// 	gtag('event', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Title - click', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Title - click'
// 	});
// });
// $('body').find('.index-rings-content .rdesign-variations').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
// 	gtag('event', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click'
// 	});
// });
// $('body').find('.index-rings-content .rdesign-variations').find('.irc-dot-item').click(function(){
// 	var this_title = $(this).parents('.rdesign').find('h4').text();
// 	var this_variations = $(this).parents('.rdesign').find('.rdesign-variations').find('a').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', 'Click');
// 	gtag('event', 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - The Legends - '+this_title+' '+this_variations+' - Item Variations - click'
// 	});
// });
// $('body').find('.index-spotted-content_new .isc-item_new').click(function(){
// 	var this_title = $(this).data('s_title');
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Spotted - Video - '+this_title+' - click', 'Click');
// 	gtag('event', 'website_clicks_desktop', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - Spotted - Video - '+this_title+' - click'
// 	});
// });
// $('body').find('.index-spotted-content_new a.isc-content-link.lp-eb-slider-btn.lp-eb-slider-btn-black.irc-btn').click(function(){
// 	var this_title = $(this).parents('.isc-item_new').data('s_title');
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Spotted - Video - '+this_title+' - View Style Btn - click', 'Click');
// 	gtag('event', 'website_clicks_desktop', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - Spotted - Video - '+this_title+' - View Style Btn - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section .hp-rt-item-block-url a').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Discover Collection - click', 'Click');
// 	gtag('event', 'website_clicks_desktop', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - Accordion Block - '+this_title+' - Discover Collection - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section .hp-rt-item-product-content a').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	var this_product = $(this).find('.hp-rt-item-pc-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Product - '+this_product+' - click', 'Click');
// 	gtag('event', 'website_clicks_desktop', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - Accordion Block - '+this_title+' - Product - '+this_product+' - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-right.slick-arrow').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Arrow Right - click', 'Click');
// 	gtag('event', 'website_clicks_desktop', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - Accordion Block - '+this_title+' - Arrow Right - click'
// 	});
// });
// $('body').find('#shopify-section-index-accordion-section a.scroll-control.scroll-left.slick-arrow').click(function(){
// 	var this_title = $(this).parents('.hp-rt-item').find('.hp-rt-item-block-title').text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Accordion Block - '+this_title+' - Arrow Left - click', 'Click');
// 	gtag('event', 'website_clicks_desktop', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - Accordion Block - '+this_title+' - Arrow Left - click'
// 	});
// });
// $('body').find('body.index .index-book-an-appointment-block .baa-desc').find('a').click(function(){
// 	var this_title = $(this).text();
// 	//ga('send', 'event', 'Front Page', 'Front Page - Desktop - Middle Book an Appointment - '+this_title+' link - click', 'Click');
// 	gtag('event', 'website_clicks_desktop', {
// 	  'event_type': 'Front Page',
// 	  'event_name': 'Front Page - Desktop - Middle Book an Appointment - '+this_title+' link - click'
// 	});
// });
$('body').find('.converted-faq').find('.faq-question').click(function(){
	var this_title = $(this).text();
	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Desktop - '+this_title+' - click', 'Click');
	gtag('event', 'Customer Service Page - Desktop - '+this_title+' - click', {
	  'event_type': 'Customer Service Page',
	  'event_name': 'Customer Service Page - Desktop - '+this_title+' - click'
	});
});
$('body').find('.converted-faq').find('.faq-item').find('a').click(function(){
	var this_title = $(this).parents('.faq-item').find('faq-question').text();
	//ga('send', 'event', 'Customer Service Page', 'Customer Service Page - Desktop - '+this_title+' - Button - click', 'Click');
	gtag('event', 'Customer Service Page - Desktop - '+this_title+' - Button - click', {
	  'event_type': 'Customer Service Page',
	  'event_name': 'Customer Service Page - Desktop - '+this_title+' - Button - click'
	});
});
$('body.collection').find('.product-index').find('a').click(function(){
	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
	var collection_title = $('body').find('.catdesc-right').find('h1').text();
	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Desktop - '+this_title+' '+this_diamonds+' - click', 'Click');
	gtag('event', 'Collection Page - Desktop - '+this_title+' '+this_diamonds+' - click', {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - Desktop - '+this_title+' '+this_diamonds+' - click'
	});
});
$('body.collection').find('.product-index').find('.col-swatch').find('.color').mouseenter(function(){
	var this_title = $(this).parents('.product-index').find('.product-info').find('a').text();
	var this_diamonds = $(this).parents('.product-index').find('.product-info').find('.pi-diamonds').text();
	var this_color = $(this).data('option-title');
	var collection_title = $('body').find('.catdesc-right').find('h1').text();
	//ga('send', 'event', collection_title+' Collection Page', collection_title+' Collection Page - Desktop - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover', 'Click');
	gtag('event', 'Collection Page - Desktop - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover', {
	  'event_type': 'Collection Page',
	  'event_name': 'Collection Page - Desktop - '+this_title+' '+this_diamonds+' - '+this_color+' - Hover'
	});
});
$('body.product').find('.rpc-item-inner-columns').find('.rpc-item-inner-column-item').click(function(){
	var this_title = $(this).find('.rpc-item-inner-column-item-title').text();
	var product_title = $('body').find('.product-description').find('h1').text();
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - '+product_title+' - '+this_title+' - click', 'Click');
	gtag('event', 'Product Page - Desktop - '+product_title+' - '+this_title+' - click', {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - Desktop - '+product_title+' - '+this_title+' - click'
	});
});
$('body.product').find('.rpc-item.rpc-item-dropdown').click(function(){
	var this_title = $(this).find('.rpc-item-title').text();
	var product_title = $('body').find('.product-description').find('h1').text();
	//ga('send', 'event', 'Product Page', 'Product Page - Desktop - '+product_title+' - '+this_title+' - click', 'Click');
	gtag('event', 'Product Page - Desktop - '+product_title+' - '+this_title+' - click', {
	  'event_type': 'Product Page',
	  'event_name': 'Product Page - Desktop - '+product_title+' - '+this_title+' - click'
	});
});

}